












































import { Component, Ref, Vue, Watch, Prop } from "vue-property-decorator";
import ProcedureItemRow from "@/components/ProcedureItemRow.vue";
import { ProcedureItem } from "@/types/diag_procedure";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: {
    ProcedureItemRow
  }
})
export default class ProcedureICDPanel extends Vue {
  @Ref() rowItem;

  @Prop({ default: [] }) items: ProcedureItem[] = [];

  addItem() {
    this.items.push({
      id: null,
      icd: null,
      name: null,
      pasien_rm: storePasien.identitasPasien.rm,
      register_id: RegisterKunjungan.register["no"],
      unit_id: userModule.user.unit_id
    });

    const rows = this.items.length,
      lastIdx = rows - 1;

    this.$nextTick(() => {
      this.rowItem[lastIdx].focus();
    });
  }

  removeItem(idx) {
    this.items.splice(idx, 1);

    const rows = this.items.length,
      lastIdx = rows - 1;
    this.$nextTick(() => {
      this.rowItem[lastIdx].focus();
    });
  }

  @Watch("items", { deep: true })
  changeData(val) {
    this.$emit("changeData", val);
  }
}
